import { hot } from 'react-hot-loader/root';
import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import NavBar from './containers/NavBar';
import Footer from './components/Footer';
import Fragno1Footer from './fragno1/Footer';
import LoadingPage from './components/LoadingPage';
import { DOMAIN, TRANSLATIONS_SUPPORTED } from './constants';
import routes from './routing/routes';
import ScrollToTop from './routing/ScrollToTop';
import AuthRoute from './routing/AuthRoute';
import { selectFragno1 } from './reducers/fragno1';

import '@idme/action-group';
import '@idme/button';
import '@idme/description-list';
import '@idme/global-nav';
import '@idme/icon';
import '@idme/id-card';
import '@idme/link';
import '@idme/modal';
import '@idme/navigation-button';

import i18n from './i18n';

class App extends Component {
  static propTypes = {
    fragno1: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
    if (window.opener) {
      try {
        window.opener.postMessage({ status: 'complete' }, DOMAIN);
      } catch (e) {
        // fail silently
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = (e) => {
    if (e && e.data && e.data.status === 'close') {
      window.close();
    }
  };

  render() {
    const { fragno1 } = this.props;

    return (
      <Suspense fallback={<LoadingPage />}>
        <Router basename={TRANSLATIONS_SUPPORTED ? i18n.language : null}>
          <ScrollToTop />
          <NavBar />
          <Switch>
            {routes.map((route) => (
              <AuthRoute key={route.path || '404'} {...route} />
            ))}
          </Switch>
          {fragno1 ? <Fragno1Footer /> : <Footer />}
        </Router>
      </Suspense>
    );
  }
}

export const mapStateToProps = (state) => ({
  fragno1: selectFragno1(state),
});

export { App };

export default hot(connect(mapStateToProps)(App));
